import React from "react";
import { useLocation } from "react-router-dom";
import { useAuthStore } from "../stores/authStore";
import type { Role } from "../models/auth";
import AccessDenied from "../components/AccessDenied";

/* Type guard: admins con acceso total */
type AdminRole = Extract<Role, "owner" | "super_admin" | "admin">;
function isAdminRole(r: Role | null | undefined): r is AdminRole {
  return r === "owner" || r === "super_admin" || r === "admin";
}

type Props = {
  /** Lista exacta de roles permitidos (los admins pasan siempre). */
  allow: readonly Role[];
  children: React.ReactNode;
};

export function RequireRole({ allow, children }: Props): React.ReactElement {
  const location = useLocation();
  const state = useAuthStore((s) => s.state);
  const start = useAuthStore((s) => s.start);

  React.useEffect(() => {
    if (state.status === "idle") start();
  }, [state.status, start]);

  if (state.status === "loading") {
    return <div className="p-6">Cargando…</div>;
  }

  // No autenticado → muestra AccessDenied
  if (!state.user) {
    return <AccessDenied />;
  }

  const role: Role | null = state.profile?.role ?? null;

  // Admins: acceso total
  if (isAdminRole(role)) {
    return <>{children}</>;
  }

  // Validar lista 'allow' para el resto
  if (allow.length > 0) {
    const allowed = role !== null && allow.includes(role);
    if (!allowed) return <AccessDenied />;
  }

  return <>{children}</>;
}
